import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

/**
 * Shown right after login when the user has access to more than one
 * store/warehouse: they must pick which one to connect to before any
 * stock-related screen loads. The choice is kept in localStorage
 * ('activeLocationId' / 'storeId') and can be switched later from the header.
 */
@Component({
  selector: 'app-select-store',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './select-store.component.html',
  styleUrl: './select-store.component.scss',
})
export class SelectStoreComponent {
  private authService = inject(AuthService);
  private router = inject(Router);

  storeAccess = this.authService.getStoreAccess();

  constructor() {
    // Nothing to choose — fall through to the app.
    if (this.storeAccess.length <= 1) {
      if (this.storeAccess.length === 1) {
        this.authService.setActiveStore(this.storeAccess[0]);
      }
      this.router.navigate([this.defaultRoute()]);
    }
  }

  select(access: any) {
    this.authService.setActiveStore(access);
    this.router.navigate([this.defaultRoute()]);
  }

  private defaultRoute(): string {
    const roleRouteMap: { [key: string]: string } = {
      Admin: '/dashboard',
      ADMIN: '/dashboard',
      SUPER_ADMIN: '/dashboard',
      CASHIER: '/billing',
      Cashier: '/billing',
      STORE_MANAGER: '/billing',
      AREA_MANAGER: '/billing',
      ASM: '/billing',
      WAREHOUSE_MANAGER: '/dashboard',
      CATEGORY_MANAGER: '/dashboard',
      MIS_TEAM: '/dashboard',
      GRN_TEAM: '/grn',
      PRN_TEAM: '/prn',
      LP_TEAM: '/product-list',
      INWARD_TEAM: '/transfer-in',
      OUTWARD_TEAM: '/transfer-out',
      StoreManager: '/billing',
      WarehouseManager: '/transfer-out',
    };
    if (this.authService.isSuperAdmin() && !this.authService.getSelectedTenantId()) {
      return '/super-admin/clients';
    }
    return roleRouteMap[this.authService.getRole()] || '/dashboard';
  }
}
